var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reimbursemnet"},[_c('approval',{attrs:{"isBillType":_vm.isBillType,"departmentId":_vm.departmentId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }